import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize'
})
export class FileSizePipe implements PipeTransform {

  transform(bytes: number, unit?: 'B' | 'KB' | 'MB' | 'GB' | 'TB', decimals: number = 2): string {
    if (bytes === 0 || isNaN(bytes)) {
      return '0 Bytes';
    }

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

    // If a specific unit is provided, convert directly
    if (unit && sizes.includes(unit)) {
      const i = sizes.indexOf(unit);
      const value = bytes / Math.pow(k, i);
      return `${parseFloat(value.toFixed(decimals))} ${unit}`;
    }

    // Otherwise, auto-determine the most appropriate unit
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const value = bytes / Math.pow(k, i);

    return `${parseFloat(value.toFixed(decimals))} ${sizes[i]}`;
  }

}
